module.exports = __webpack_public_path__ + "img/hailang.79319d8a.png";